module.exports = __webpack_public_path__ + "img/mapna.1beda0b.webp";